import { groupBadgeStyle, groupStyle } from "@/lib/accountGroups";

export default function GroupSelect({ value, groups, onChange, className = "", compact = false }) {
  const selected = groups.find((g) => g.name === value);

  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
      onClick={(e) => e.stopPropagation()}
      title="Assign account group"
      style={selected ? groupBadgeStyle(selected.color) : undefined}
      className={`border font-mono-d uppercase tracking-wider font-bold focus:outline-none focus:ring-2 focus:ring-app-accent/40 ${
        compact ? "text-[10px] px-2 py-1" : "text-xs px-2.5 py-1.5 min-h-[36px]"
      } ${selected ? "border-current shadow-sm" : "border-app-border bg-app-surface text-app-text"} ${className}`}
    >
      <option value="">No group</option>
      {groups.map((g) => (
        <option key={g.name} value={g.name}>{g.name}</option>
      ))}
    </select>
  );
}
